import { Navigate } from 'react-router'
import { useUserState } from '~/atoms/UserState'
import { ApplicationRoutes } from '~/types/RoutingTypes'
import { shouldUseHotelsExperience } from '~/utils/pbxUtils'

import type { Pbx } from '@mangovoice/types'

interface ResolveDefaultHomeRouteParams {
  pbx?: Pick<Pbx, 'industry_type'> | null
}

export const resolveDefaultHomeRoute = ({
  pbx,
}: ResolveDefaultHomeRouteParams = {}): string =>
  shouldUseHotelsExperience({ pbx })
    ? ApplicationRoutes.HOTELS
    : ApplicationRoutes.CALLS

export const DefaultHomeRoute = () => {
  const { isReady, pbx } = useUserState({
    canAutoRefresh: false,
  })

  if (!isReady) {
    return null
  }

  return <Navigate to={resolveDefaultHomeRoute({ pbx })} replace />
}
